import React from "react";
import { Stack, Paper, Typography, Skeleton } from "@mui/material";
import { ClearCallLogoTitle } from "../../../components/clear-call-logo";
import { MeetingSurveyQuestions } from "../../../components/meeting/survey";
import { useGetMeetingJoinInfo } from "../../../store";

interface MeetingSurveyPanelProps {
  meetingId: string;
  userId: string;
  joinCode: string;
}

const MeetingSurveyPanel: React.FC<MeetingSurveyPanelProps> = ({
  meetingId,
  userId,
  joinCode,
}) => {
  const { data: joinInfo, isLoading } = useGetMeetingJoinInfo(
    meetingId,
    userId,
    joinCode,
  );

  return (
    <Paper
      elevation={20}
      sx={{
        width: 1000,
        p: 4,
        alignItems: "center",
        borderRadius: 2,
      }}
    >
      <Stack
        spacing={3}
        alignItems="center"
        justifyContent="center"
        sx={{ width: "100%", pt: 2 }}
      >
        <ClearCallLogoTitle size={150} />
        <Typography variant="h4" align="center">
          Please provide feedback about the meeting quality:
        </Typography>
        {isLoading ? (
          <Skeleton variant="rounded" width="280px" height="150px" />
        ) : (
          <MeetingSurveyQuestions
            questionIdList={["0001", "0002"]}
            meetingId={meetingId}
            userId={userId}
            joinCode={joinCode}
            survey={joinInfo?.survey}
          />
        )}
        <Typography variant="body1" align="center">
          Once finished you can close this tab.
        </Typography>
      </Stack>
    </Paper>
  );
};

export default MeetingSurveyPanel;
